import { t } from "@lingui/core/macro";
import { RouteProp, useNavigation, useRoute } from "@react-navigation/native";
import { ScrollView } from "react-native";
import { useSafeAreaInsets } from "react-native-safe-area-context";

import { PackageOrder } from "@/features/Packages";
import { PackageOrderFooter } from "@/features/Packages/PackageOrderFooter";
import { PackagesStackNavigatorParamList } from "@/navigators/ProfileStackNavigator/PackagesStackNavigator";
import { Container } from "@whoosh/design-system/src/apps/PatronApp/layout/Container";
import { ScreenHeader } from "@whoosh/design-system/src/apps/PatronApp/layout/ScreenHeader";
import { Button } from "@whoosh/design-system/src/components/controls";
import { ArrowLeftIcon } from "@whoosh/design-system/src/components/icons_v2/general";
import { Box } from "@whoosh/design-system/src/components/primitive";

export const PackageOrderScreen = () => {
  const insets = useSafeAreaInsets();
  const navigation = useNavigation();
  const route =
    useRoute<RouteProp<PackagesStackNavigatorParamList, "PackageOrder">>();

  const orderId = route.params.orderId;
  const packageId = route.params.packageId;

  const onBack = () => {
    navigation.goBack();
  };

  return (
    <Box
      bg="surface-primary"
      flex={1}
      style={{ paddingTop: insets.top, paddingBottom: insets.bottom }}
    >
      <Container flex={1} paddingHorizontal={0}>
        <ScreenHeader
          title={t`Outstanding Order`}
          leftItem={
            <Button
              variant="secondary"
              accessibilityLabel={t`Back Button`}
              leftIcon={<ArrowLeftIcon />}
              onPress={onBack}
              testID="mobile-header-back-button"
            />
          }
          testID="package-outstanding-order-screen-header"
        />
        <ScrollView style={{ paddingTop: 16 }}>
          <PackageOrder packageId={packageId} orderId={orderId} />
        </ScrollView>
        <PackageOrderFooter packageId={packageId} orderId={orderId} />
      </Container>
    </Box>
  );
};
